export default __webpack_public_path__ + "static/node_runner@2x-f8ec73579d2adbb8d05c5aa5b33e074c.png";